/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type DraftStatusCell_ConfigurationFragment = { __typename: 'ConfigurationModel', id: string, version: number, draft?: { __typename: 'ConfigurationModel', id: string } | null };

export const DraftStatusCell_ConfigurationFragmentDoc = gql`
    fragment DraftStatusCell_configuration on ConfigurationModel {
  id
  version
  draft {
    id
  }
}
    `;